import { PATH_AUTH_SPA, PATH_REGISTER } from 'src/constants/spa-routes';

export const windowReloadHandler = () => {
  const ignoreReloadUrls = [
    PATH_AUTH_SPA.ROOT,
    PATH_REGISTER.ROOT,
    PATH_REGISTER.GOOGLE,
    PATH_REGISTER.EMAIL,
    PATH_REGISTER.SIGN_UP,
  ];
  const isReloadRequired = !ignoreReloadUrls.filter((url) => globalThis.location.href.includes(url))
    .length;

  if (isReloadRequired) {
    globalThis.location.reload();
  }
};
